import { forwardRef } from 'react';
import { handleEventWithAnalytics } from '@mwl/core-lib';
import { getTestProps, omitTestProps } from '@mwl/marker-tree';
import { Checkbox as MwlCheckbox } from '@mwl/ui';
import CheckIcon from '@public/assets/common/icons/check.svg';
import type { CheckboxProps } from './Checkbox.types';
import styles from './Checkbox.module.scss';
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  className,
  classes,
  checked,
  onChange,
  analytics,
  ...props
}, ref) => {
  const analyticsEvent = checked ? analytics?.uncheck : analytics?.check;
  const analyticsClassName: string | undefined = analyticsEvent?.data?.cls || 'checkbox';
  const analyticsData = {
    ...(analyticsEvent?.data || {}),
    cls: analyticsClassName
  };
  return <MwlCheckbox ref={ref} wrapperProps={getTestProps(props)} className={className} checked={checked} onChange={handleEventWithAnalytics(onChange, analyticsEvent?.eventName, analyticsData)} classes={{
    input: analyticsClassName,
    box: cn(styles.box, classes?.box),
    content: classes?.text
  }} {...props} icon={<CheckIcon className={styles.icon} />} radius="xl" {...omitTestProps(props)} />;
});
Checkbox.displayName = 'Checkbox';
export * from './Checkbox.types';
export { Checkbox };